import React from 'react';
import StemOutReachContainer from '../../../Containers/UserContainer/StemOutreach';

const StemOutReachScreen = () => {
  return <StemOutReachContainer />;
};

export default StemOutReachScreen;
